const canUncheckRadioLabels = document.querySelectorAll(
  'label[data-radio-can-uncheck]'
);

if (canUncheckRadioLabels) {
  Array.from(canUncheckRadioLabels).forEach(radioLabel => {
    radioLabel.addEventListener('click', e => {
      e.preventDefault();
      const radio = radioLabel.querySelector('input');
      if (radio) {
        radio.checked = !radio.checked;
      }
    });
  });
}
